export const MIN_BALANCE = '0.01'
